import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@mui/material';

import { IBookModel } from '@common/models/Books/Book';

import LessonsLinkItem from './Item';
import { StyledLessonLinkList } from './styled';

interface PropsType {
	books: IBookModel[];
}

function LinkSectionBooks({ books }: PropsType) {
	const { t } = useTranslation();
	if (!books || books?.length <= 0) return null;

	return (
		<>
			<Typography variant="subtitle2">{t('lesson.books')}</Typography>
			<StyledLessonLinkList>
				{books.map((book) => (
					<LessonsLinkItem
						key={book.id}
						title={book.name}
						href={book.pdf_url}
						download={`${book.name}.pdf`}
					/>
				))}
			</StyledLessonLinkList>
		</>
	);
}

export default LinkSectionBooks;
